<template>
  <div>
    <ProgramPageHeader :name="name" :pageId="pageId" />
    <v-container fluid>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import ProgramPageHeader from "@/modules/program_pages/components/ProgramPageHeader";
export default {
  components: {
    ProgramPageHeader,
  },
  computed: {
    name() {
      const active = this.$store.getters["ProgramPageStore/cache"];
      return active?.internal_title || active?.title || "";
    },
    pageId() {
      return this.$store.getters["ProgramPageStore/id"];
    },
  },
  mounted() {
    const pageId = this.$route.params.id;
    this.$store.dispatch("ProgramPageStore/getOneProgramPage", pageId).catch((err) => this.$root.$error(err));
  },
};
</script>
